import { gql } from "@apollo/client";

const BREAKDOWN_ITEM = gql`
    fragment BreakdownItem on ConsumptionBreakdownItem {
        ownershipType
        vertical
        emission
        from
        to
    }
`;

export const GET_CONSUMPTION_CHART_DATA = gql`
    query GetConsumptionChartData(
        $assetId: ID!
        $bfe: String!
        $from: DateTime
    ) {
        getConsumptionChartData(assetId: $assetId) {
            emission {
                ...BreakdownItem
            }
            energy {
                ...BreakdownItem
            }
            projectedEmission {
                ...BreakdownItem
            }
            projectedEnergy {
                ...BreakdownItem
            }
            year
        }

        getLegacyNextAssetBenchmarks(bfe: $bfe, from: $from) {
            segment
            co2BenchmarkMethod1
            kwhMethod1
            benchmarkType
            startTs
        }
    }
    ${BREAKDOWN_ITEM}
`;
